"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Netsmart = void 0;
const EmrConstants_1 = require("../../EmrConstants");
const helper_1 = require("../../helper");
class Netsmart {
    constructor() { }
    /**********************************************************************************************************************
     *                     START : NETSMART Software Parser
     * ********************************************************************************************************************/
    /**
     * @function parse
     * @param pastedData
     * @summary netSmartSoftwareParser Software Parser @pastedData string break by session to session
     * @returns {callback}
     */
    parse(pastedData, event, callbackEmit) {
        pastedData = pastedData.replace(/\r\n/g, "\n");
        try {
            if ((pastedData.indexOf("Episode:") !== -1 &&
                pastedData.indexOf("Chart:") !== -1) ||
                pastedData.indexOf("Select a") !== -1 ||
                pastedData.indexOf("Select One") !== -1) {
                this.deveroType = EmrConstants_1.DEVERO_TYPE.EDITABLE;
            }
            let patientInfoString;
            if (pastedData.indexOf("Synergy Patient ID:") == -1) {
                //**Session 1 Patient name*/
                patientInfoString = (0, helper_1.substrInBetween)(pastedData, "Patient Information:", "HAS Patient ID:");
            }
            else {
                patientInfoString = (0, helper_1.substrInBetween)(pastedData, "Patient Information:", "Synergy Patient ID:");
            }
            const sessionFirst = (0, helper_1.substrInBetween)(patientInfoString, "First Name:", "Suffix:");
            //**Session 2 Patient Information*/
            const sessionSecond = (0, helper_1.substrInBetween)(patientInfoString, "Last Name:", "Age:");
            const patientInfo = this.gettingPatientDetails(sessionFirst, sessionSecond);
            //**Session 3 Insurance*/
            const sessionThird = (0, helper_1.substrInBetween)(pastedData, "Primary Insurance:", "Secondary Insurance:");
            const insurance = this.getInsurance(sessionThird);
            //**Session 6 Emergency Contact*/
            const sessionSix = (0, helper_1.substrInBetween)(pastedData, "Emergency Contact Information:", "Emergency Contact 2:");
            //**Session 7 Primary Physician*/
            const sessionSeven = (0, helper_1.substrInBetween)(pastedData, "Physician Information:", "Certifying/F2F Physician:");
            //**Session 8 Pharmacy*/
            const sessionEight = (0, helper_1.substrInBetween)(pastedData, "Pharmacy:", "Comments");
            const physicianInfo = this.getPrimaryPhysician(sessionSix, sessionSeven, sessionEight);
            //**Session 9 Comments*/
            const comment = this.getComment(patientInfoString);
            const sendCallBackData = Object.assign(Object.assign(Object.assign(Object.assign({}, patientInfo), insurance), physicianInfo), comment);
            //@callback
            callbackEmit({ parseData: sendCallBackData });
        }
        catch (error) {
            //For Error logs
            callbackEmit({
                parseData: {},
                isDataParsed: 0,
                errorMessage: error ? error.message : error,
                errorStack: error.stack,
            });
        }
    }
    /**
     * @function gettingPatientDetails
     * @param sessionFirst {String}
     * @param sessionSecond {String}
     * @summary Getting Patient name, number, email, dob, address from netsmart
     */
    gettingPatientDetails(sessionFirst, sessionSecond) {
        if (!sessionSecond) {
            return {};
        }
        let dobString = sessionSecond.split("Birth Date:")[1];
        //Break DOB
        if (dobString) {
            const lastFour = dobString.substr(dobString.length - 4);
            dobString = dobString.replace(lastFour, ` ${lastFour}`);
        }
        return {
            patientInfo: Object.assign(Object.assign(Object.assign({}, this.patientName(sessionFirst)), this.patientPhoneNumberWithAddress(sessionSecond)), { email: (0, helper_1.getEmailAddress)(sessionSecond), dob: (0, helper_1.getDOB)((0, helper_1.trim)(dobString), true) }),
        };
    }
    /**
     * @function getInsurance
     * @param sessionThird
     * @summary Getting Insurance from netsmart
     */
    getInsurance(sessionThird) {
        if (!sessionThird) {
            return {};
        }
        const convertToArray = sessionThird.split(/\n/g);
        //Primary Insurance and Secondary Insurance
        return {
            insurance: (0, helper_1.trim)(convertToArray[0]
                ? convertToArray[0] == "(Select an Insurance)"
                    ? " "
                    : convertToArray[0]
                : ""),
        };
    }
    /**
     * @function getPrimaryPhysician
     * @param data
     * @param sessionEight
     * @summary Getting Physician and Pharmacy from netsmart
     */
    getPrimaryPhysician(sessionSix, sessionSeven, sessionEight) {
        const primaryPhy = {
            info: {
                physician: [
                    {
                        name: "",
                        phoneNo: "",
                        countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                        sortOrder: 1,
                    },
                ],
                pharmacy: [this.getPharmacy(sessionEight)],
                careGiver: [this.getCaregiver(sessionSix)],
            },
        };
        //Blank data Return
        if (!sessionSeven) {
            return primaryPhy;
        }
        //Find name
        const nameInArray = sessionSeven.split(/\n/g);
        //Primary Physician name
        primaryPhy.info.physician[0].name = `${this.getPhyCareName(nameInArray, "Physician's First Name:")} ${this.getPhyCareName(nameInArray, "Physician's Last Name:")}`;
        //**Update String for Number of Address*/
        sessionSeven = (0, helper_1.substrInBetween)(sessionSeven, "Phone:", "Fax:");
        if (sessionSeven) {
            const number = (0, helper_1.trim)(sessionSeven.replace(/[\s-()]/g, ""));
            if (number.indexOf("/") != -1) {
                const phoneNumber = number.split("/");
                primaryPhy.info.physician[0].phoneNo = (0, helper_1.changeNumberUSFormat)(phoneNumber[0]);
            }
            else {
                primaryPhy.info.physician[0].phoneNo = (0, helper_1.changeNumberUSFormat)(number);
            }
        }
        //@Return
        return primaryPhy;
    }
    getPhyCareName(data, findName) {
        let name = "";
        for (let nIndex = 0; nIndex < data.length; nIndex++) {
            const txt = data[nIndex];
            if (txt.indexOf(findName) != -1) {
                switch (this.deveroType) {
                    case EmrConstants_1.DEVERO_TYPE.EDITABLE:
                        if (data[nIndex + 1].indexOf("Physician's Last Name:") != -1 ||
                            data[nIndex + 1].indexOf("PECOS Status:") != -1) {
                            name = (0, helper_1.trim)(txt.replace(findName, ""));
                        }
                        else {
                            name = (0, helper_1.trim)(data[nIndex + 1]);
                        }
                        break;
                    default:
                        name = (0, helper_1.trim)(txt.replace(findName, ""));
                        break;
                }
                break; //Break Loop
            }
        }
        //Return name
        return name;
    }
    /**
     * @function getPharmacy
     * @param data
     */
    getPharmacy(data) {
        const pharmacyData = {
            name: "",
            phoneNo: "",
            countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
            sortOrder: 1,
        };
        //@Return
        return pharmacyData;
    }
    getCaregiver(data) {
        const caregiverData = {
            name: "",
            phoneNo: "",
            countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
            sortOrder: 1,
        };
        //Blank data Return
        if (!data) {
            return caregiverData;
        }
        //Find name
        const nameInArray = data.split(/\n/g);
        //Primary Physician name
        caregiverData.name = `${this.getPhyCareName(nameInArray, "Emergency Contact 1:")}`;
        //**Update String for Number of Address*/
        const numberString = (0, helper_1.substrInBetween)(data, "Emergency Contact Telephone No:", "Relationship:");
        if (numberString) {
            const number = (0, helper_1.trim)(numberString.replace(/[\s-()]/g, ""));
            caregiverData.phoneNo = (0, helper_1.changeNumberUSFormat)(number);
        }
        //Bind name with Relationship
        if (caregiverData.name) {
            const relationship = (0, helper_1.substrInBetween)(data, "Relationship:", "Emergency Contact Address:");
            if (relationship) {
                caregiverData.name += ` (${relationship})`;
            }
        }
        //@Return
        return caregiverData;
    }
    /**
     * @function patientPhoneNumberWithAddress
     * @param pastedData
     * @summary Patient number or Address both are same session
     */
    patientPhoneNumberWithAddress(addressString) {
        const info = {
            phoneNo: "",
            address: {
                placeName: "",
            },
        };
        //String not found
        if (!addressString) {
            return info;
        }
        let addressInArray = [];
        //**Update string : Getting data from between Referral Date and Email Address */
        addressInArray = (0, helper_1.substrInBetween)(addressString, "Suffix:", "Map")
            .replace(/(?:\r\n|\r|\n)/g, " ")
            .split(/City:|State:|Zip Code:|Map/g);
        let fullAddress = "";
        addressInArray.forEach((address, index) => {
            if (address.indexOf("Street:") != -1) {
                fullAddress += `${(0, helper_1.substrInBetween)(address, "Street:", "Suite/Apt #:")},`;
            }
            if (index === 1) {
                fullAddress += `${(0, helper_1.trim)(address)}, `;
            }
            if (index === 2) {
                fullAddress += `${(0, helper_1.trim)(address)}, `;
            }
            if (index === 3) {
                fullAddress += (0, helper_1.trim)(address);
            }
        });
        info.address.placeName = (0, helper_1.trim)(fullAddress);
        if (fullAddress.indexOf(",, Select,") != -1) {
            info.address.placeName = "";
        }
        //Personal Number
        let numberStrings = (0, helper_1.substrInBetween)(addressString, "Primary Phone:", "Secondary Phone:");
        //Check home number
        if (!numberStrings) {
            numberStrings = (0, helper_1.substrInBetween)(addressString, "Home Phone:", "Cell Phone:");
            //Break numbers
            if (numberStrings) {
                const number = numberStrings.replace(/[\s-()]/g, "");
                info.phoneNo = (0, helper_1.changeNumberUSFormat)(number);
            }
            return info;
        }
        const numberAr = numberStrings.split("\n");
        numberStrings = numberAr[1];
        //Break numbers
        if (numberStrings) {
            const number = numberStrings.replace(/[\s-()]/g, "");
            info.phoneNo = (0, helper_1.changeNumberUSFormat)(number);
        }
        //@Return address or phoneNo
        return info;
    }
    /**
     * @function patientName
     * @param sessionFirst {String}
     * @summary Getting Patient First name, Last name from string
     * @returns {name} FullName
     */
    patientName(sessionFirst) {
        const name = {
            firstName: "",
            lastName: "",
        };
        //**replacing Last name: string.*/
        const nameSession = sessionFirst.replace("Last Name:", "");
        if (!nameSession) {
            return name;
        }
        const convertToArray = nameSession.replace(/\n/g, "$hg").split("$hg");
        //Verify name Arrayand checking index of name attribute
        if (!convertToArray && !convertToArray.length) {
            return name;
        }
        // Patient Name using
        const fName = convertToArray[0].indexOf("-") != -1
            ? convertToArray[0].substr(0, convertToArray[0].indexOf("-"))
            : convertToArray[0];
        name.firstName = (0, helper_1.trim)(fName); //FirstName
        //LastName
        if (convertToArray.length > 1) {
            name.lastName = (0, helper_1.trim)(convertToArray[convertToArray.length - 1]);
        }
        //@Return name
        return name;
    }
    /**
     * @function getComment
     * @param comment
     * @summary Getting Comment filed from kinnser
     */
    getComment(comment) {
        const commentInArray = comment.split("Comments:");
        const commentText = commentInArray[commentInArray.length - 1]
            ? commentInArray[commentInArray.length - 1].trim()
            : "NONE";
        if (commentText !== "NONE") {
            return { about: commentText };
        }
    }
}
exports.Netsmart = Netsmart;
